export const ContentHeight = {
  ISNEW_HEIGHT: 374,
  STANDARD_HEIGHT: 331,
  REJECTED_HEIGHT: 491
} as const
